export default __webpack_public_path__ + "static/media/consoleLogo.fa54a3d1.svg";